import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo,systemConfig,getZkShopName,getTaoteShopName } from '../../utils/http';
import { Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import './orderBackflowSet.less';
import PlatformName from '../../components/platformName/index.jsx';
import ShowModal from '../../components/showModal/index.jsx';
import $ from 'jquery';
import NewUserGuide from '../../components/newUserGuide/index.jsx';

class orderBackflowSet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      loadingTitle: '加载店铺信息...',
      ParentId: "0",//目录父级ID
      isAutoConfirm: 0,
      isAutoPay: 0,
      openUrl: 'https://tradeconfig.1688.com/foundation/withhold_manage.htm',//开通自动代扣的跳转链接，默认赋值一个链接，会通过后台请求覆盖

      isShowModalByVerifyOpen: false,//是否显示弹窗（自动代扣的确认）

      selectShopId: "",//当前登录的店铺id，非阿里的
      selectShopName:'',//列表显示的店铺名称
      selectPlatformType: "WxVideo",//当前登录的店铺类型

    };
  }
  componentDidMount() {
    var zhukeToken = getToken();
    var that = this;
    if (zhukeToken != "")
      that.loadData();
    else {

      setTimeout(() => {
        var zhukeTokenTwo = getToken();
        if (zhukeTokenTwo == "") {
          var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
          //var hasZhukeLoginShopTokens = "";//测试。
          if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
            loadZhuKeToken(hasZhukeLoginShopTokens);

            setTimeout(() => {
              var zhukeTokenThree = getToken();
              if (zhukeTokenThree != "")
                that.loadData();
              else
                that.setState({ isShowWarn: true });

            }, 500);
          } else
            that.setState({ isShowWarn: true });
        } else
          that.loadData();
      }, 500);

    }
  }

  changeNav = (name) => {
    this.props.history.replace(name)
  }
  loadData = () => {
    var shopInfo=getLoginShopInfo();
    var that=this;
    this.setState({
      selectShopId:shopInfo.loginShopId,
      selectShopName:shopInfo.loginShopName,
      selectPlatformType:shopInfo.loginShopPlatformType,
    },()=>{
      that.loadSetInfo();
    })


    setTimeout(() => {
      this.loadApiByOpenPay(false);
    }, 1000);

  }




  loadSetInfo=()=>{
    this.setState({ isLoading: true,loadingTitle:"加载配置信息..."});

    var that=this;
    requests({
        url: "/ListingConfig/SystemSetinfoConfigGet",
        data: {ShopId:this.state.selectShopId},
        success: function (res) {
            that.setState({ isLoading: false });
            if (res.Success) {
              var config = res.Data.OrderAutoOperateConfig;
              var isAutoConfirm = "0";
              if (config != null && config.IsAutoConfirm == "1")
                  isAutoConfirm = "1";

              var isAutoPay = "0";
              if (config != null && config.IsAutoPay == "1")
                  isAutoPay = "1";

              //正常就赋值选中的即可，但是测试发现，没有对曾经赋值ture的，赋值到false,onChange会失效，又涉及切换店铺，所以就初始化下值
              if (isAutoConfirm == "0") {
                  $("input[name=operationTypeName][value='0']").prop('checked', true);
                  $("input[name=operationTypeName][value='1']").prop('checked', false);
                  $("input[name=autoRadioName][value='createOrder']").prop('checked', false);
                  $("input[name=autoRadioName][value='createOrderAndAutoPay']").prop('checked', false);
              }
              else if (isAutoConfirm == "1" && isAutoPay == "0") {
                  $("input[name=operationTypeName][value='0']").prop('checked', false);
                  $("input[name=operationTypeName][value='1']").prop('checked', true);
                  $("input[name=autoRadioName][value='createOrder']").prop('checked', true);
                  $("input[name=autoRadioName][value='createOrderAndAutoPay']").prop('checked', false);
              } else if (isAutoConfirm == "1" && isAutoPay == "1") {
                  $("input[name=operationTypeName][value='0']").prop('checked', false);
                  $("input[name=operationTypeName][value='1']").prop('checked', true);

                  $("input[name=autoRadioName][value='createOrder']").prop('checked', false);
                  $("input[name=autoRadioName][value='createOrderAndAutoPay']").prop('checked', true);

              }
            } else {
              Message({
                showClose: true,
                message: "初始化信息错误：" + res.Message,
                type: 'error'
              });
            }
        },
        fail: (err) => { }
    });
  }


  notOpenShowModalByConfirm = () => {
    //前往开通后，2秒弹出这个验证框
    var url = decodeURIComponent(this.state.openUrl);//跳转去开通代扣的链接，这个链接是开通了白名单
    window.open(url);

    setTimeout(() => {
       this.setState({isShowModalByVerifyOpen:true});
    }, 1500);
  }

  
  //检测是否开通了免密支付
  loadApiByOpenPay(isLoading) {
    var that=this;
    this.setState({isShowModalByVerifyOpen:false});
    if(isLoading ==true)
       this.setState({ isLoading: true, loadingTitle:"检查是否开通自动代扣..."});


    requests({
        url: "/ListingConfig/GetApiByOpenPay",
        data: { SystemVersions: 'pc' },
        success: function (res) {
          if(isLoading ==true)
            that.setState({ isLoading: false});

          if (res.Success) {
            if(res.Data.IsOpenAutoPay ==true || res.Data.IsOpenAutoPay == "True")
            {
                $("input[name=autoRadioName][value='createOrderAndAutoPay']").attr("disabled", false);
                Message({showClose: true,message: "自动代扣已开通，选项【自动下采购单并支付】可选择。",type: 'success'});
            }else
                Message({showClose: true,message: "自动代扣未开通，选项【自动下采购单并支付】已禁选！",type: 'warning'});
          }else
            Message({showClose: true,message: "获取自动代扣错误：" + res.Message,type: 'error'});

        },
        fail: (err) => { }
      });

  }

  //跳转到代销商品页面
  gotoProxyProduct=()=>{
    this.props.history.replace("/proxyProduct");
  }

  

  operationTypeChange = (e, values) => {
    if (values == "0") {
        $("input[name=autoRadioName][value='createOrder']").prop('checked', false);
        $("input[name=autoRadioName][value='createOrderAndAutoPay']").prop('checked', false);
        this.setState({ isAutoConfirm: 0, isAutoPay: 0 }, () => {
            this.saveSetInfo();
        });
    }
    else if (values == "1") {
        $("input[name=autoRadioName][value='createOrder']").prop('checked', true);//
        this.setState({ isAutoConfirm: 1, isAutoPay: 0 }, () => {
            this.saveSetInfo();
        });
    }

  }


  autoRadioChange = (e, values) => {
    $("input[name=operationTypeName][value='1']").prop('checked', true);
    $("input[name=operationTypeName][value='0']").prop('checked', false);
    if (values == "createOrder") {
        this.setState({ isAutoConfirm: 1, isAutoPay: 0 }, () => {
            this.saveSetInfo();
        });
    }
    else if (values == "createOrderAndAutoPay") {
        this.setState({ isAutoConfirm: 1, isAutoPay: 1 }, () => {
            this.saveSetInfo();
        });
    }
 }

 saveSetInfo=()=>{
  if (this.state.isShowWarn ==true) {
    Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
    return;
  }


  this.setState({ isLoading: true,loadingTitle:"设置保存..."});

  var data={
      ShopId:this.state.selectShopId,
      PlatformType:this.state.selectPlatformType,
      IsAutoConfirm: this.state.isAutoConfirm,
      IsAutoPay: this.state.isAutoPay,
      SaveType:"orderBackflowSet",
  };

  var that=this;
  requests({
      url: "/ListingConfig/SystemSetinfoConfigValue",
      data: data,
      success: function (res) {
          that.setState({ isLoading: false });
          if (res.Success) {
            Message({
              showClose: true,
              message: "设置成功",
              type: 'success'
            });
          } else {
              that.setState({ orderBackflowSwitch: !that.state.orderBackflowSwitch });
              Message({
                showClose: true,
                message: "初始化信息错误：" + res.Message,
                type: 'error'
              });
          }
      },
      fail: (err) => { }
    });
  }


  //关闭模板弹窗  --公共
  closeModal = (modalName) => {
    this.setState({
      [modalName]: false
    })
  }




  render() {

    return (
      <div className='wrap'>
        <HeaderMenu />
        <main>
          <div className='wrap-left scroll-x' >
            <NavMenu changeNav={this.changeNav} defaultActive={"/orderBackflowSet"} />
          </div>
          <div className="wrap-right">
          <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>
            <div className="distriButionWrap distributionSetWrap mywrap">
              <div className='distributionSet'>
                <div className="distributionSet-title mainColor">订单回流设置</div>
                <div className="distributionSet-three orderBackSet">
                  <div className='orderBackSet-up'>
                    <input name="operationTypeName" type="radio" value="0" onChange={(e) => this.operationTypeChange(e, "0")}></input>
                    <span>批量手动下采购单付款</span>
                  </div>
                  <span className='orderBackSet-down'>小店顾客下单后，订单实时同步至铺货代发系统，您可以全选确认后订单同步到1688厂家生产采购单。(订单回流至1688厂家前，买家可修改地址，会同步更新)</span>
                </div>

                <div className="distributionSet-three orderBackSet">
                  <div className='orderBackSet-up'>
                    <input name="operationTypeName" type="radio" value="1" onChange={(e) => this.operationTypeChange(e, "1")}></input>
                    <span>自动下采购单/付款</span>
                    <span style={{marginLeft:'10px',color: "rgb(255, 81, 28)"}}>注意:暂不支持淘特货源订单自动下单付款</span>
                  </div>
                  <span className='orderBackSet-down'>当店铺产生代销商品订单后,订单实时自动下单/付款给1688厂家生产采购订单(买家修改地址，无法同步更新)<a className="defColor hover" target="_blank" href='https://www.yuque.com/docs/share/bbe432e0-1093-46e5-a81f-bede69ea34d8?#%20%E3%80%8A%E4%BA%86%E8%A7%A3%E5%A6%82%E4%BD%95%E8%87%AA%E5%8A%A8%E4%B8%8B%E5%8D%95%E3%80%8B'>了解如何自动下单</a></span>
                  <span className='orderBackSet-down' style={{ color: "#FF511C" }}>请注意核对代销商品对应1688货源的规格是否关联正确  <span onClick={() => this.gotoProxyProduct()} className="defColor hover">查看代发商品规格映射</span> </span>
                  <div className="distributionSet-three  orderBackSet">
                    <div className="distributionSet-three">
                      <div className="orderBackSet-up">
                        <input name='autoRadioName' type="radio" value="createOrder" onChange={(e) => this.autoRadioChange(e, "createOrder")} />
                        <span>仅自动下采购单</span>
                      </div>
                    </div>
                    <div className="distributionSet-three">
                      <div className="orderBackSet-up">
                        <input name='autoRadioName' type="radio" disabled="disabled" value="createOrderAndAutoPay" onChange={(e) => this.autoRadioChange(e, "createOrderAndAutoPay")} />
                        <span>自动下采购单并支付(需先</span><span onClick={() => this.notOpenShowModalByConfirm()} className="defColor hover">开启支付宝免密支付</span>  <span>)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <ShowModal showModal={this.state.isShowModalByVerifyOpen} hideBtn={true} titleName={'提示'} >
                <div className="showModalWrap-box-commonContent">
                  <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
                    <i className="iconfont icon-gantan icofontStatus"></i>
                    <span>操作完成后，请根据情况进行确认</span>
                  </div>
                </div>
                <div className="showModalWrap-box-commonfooter">
                  <span className="showModalWrap-box-footer-btn" onClick={() => this.loadApiByOpenPay(true)}>已开通自动代扣</span>
                  <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowModalByVerifyOpen")}>未开通</span>
                </div>

              </ShowModal>


            </div>

          </div>
        </main>


        <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
        <NewUserGuide></NewUserGuide>
      </div>

    )
  }
}

export default orderBackflowSet;


// WEBPACK FOOTER //
// ./src/pages/orderBackflowSet/orderBackflowSet.jsx